import React, {useState, createContext, useContext} from 'react';

const AuthContext = createContext();

function AuthProvider(props) {
  const [loggedIn, setLoggedIn] = useState(
    localStorage.getItem('Authorization') != null,
  );

  const login = token => {
    localStorage.setItem('Authorization', token);
    setLoggedIn(true);
  };
  const logout = () => {
    localStorage.removeItem('Authorization');
    setLoggedIn(false);
  };

  return (
    <AuthContext.Provider
      value={{
        login,
        logout,
        loggedIn,
        getAuthToken: () => localStorage.getItem('Authorization'),
      }}
      {...props}
    />
  );
}

const useAuth = () => useContext(AuthContext);

export {AuthProvider, useAuth};
